// Utils
export const NairaFormat = new Intl.NumberFormat("en-NG", {
	maximumFractionDigits: 0,
	currency: "NGN",
	style: "currency",
});

export const getNairaFormat = (amount) => {
	if (amount) {
		amount = amount.replaceAll("₦", "");
		amount = amount.replaceAll(",", "");
		return NairaFormat.format(amount);
	}
	return NairaFormat.format(0);
};

export const getUserName = (data) => {
	if (data?.userId?.firstName) {
		return data?.userId?.firstName + " " + data?.userId?.lastName;
	} else if (data?.user?.firstName) {
		return data?.user?.firstName + " " + data?.user?.lastName;
	} else return "---";
};

export const getSessionToken = () => {
	const localUser = JSON.parse(localStorage.getItem("Parse/FortCore/currentUser"));
	return localUser?.sessionToken;
};

export const getRequestValue = (data) => {
	if (data?.leaseSource) {
		return data?.leaseSource?.includes("products") ? "New" : "Existing";
	}
	return data?.requestType?.includes("old") ? "Existing" : "New";
};

export const getFilteredTableData = (selectedDate, TableData) => {
	// Filter TableData based on date - All Time, Today, Last 7 days, Last 30 days, Last 6 months, Last 12 months
	let filteredTableData = [];
	const today = new Date();

	switch (selectedDate) {
		case "Today":
			filteredTableData = TableData.filter((item) => {
				const itemDate = new Date(item.createdAt);
				// return itemDate.getDate() === today.getDate();
				return itemDate.toDateString() === today.toDateString();
			});
			break;
		case "Week":
			filteredTableData = TableData.filter((item) => {
				const itemDate = new Date(item.createdAt);
				const priorDate = new Date(new Date().setDate(today.getDate() - 7));
				return itemDate >= priorDate;
			});
			break;
		case "Month":
			filteredTableData = TableData.filter((item) => {
				const itemDate = new Date(item.createdAt);
				const priorDate = new Date(new Date().setDate(today.getDate() - 30));
				return itemDate >= priorDate;
			});
			break;
		case "6 Months":
			filteredTableData = TableData.filter((item) => {
				const itemDate = new Date(item.createdAt);
				const priorDate = new Date(new Date().setDate(today.getDate() - 180));
				return itemDate >= priorDate;
			});
			break;
		case "Year":
			filteredTableData = TableData.filter((item) => {
				const itemDate = new Date(item.createdAt);
				const priorDate = new Date(new Date().setDate(today.getDate() - 365));
				return itemDate >= priorDate;
			});
			break;
		default:
			filteredTableData = TableData;
	}

	return filteredTableData;
};

export const randomId = () => {
	return Math.floor(Math.random() * Date.now()).toString(16);
};

export const getLeasor = (data) => {
	if (data?.assetObj) {
		const investors = data?.assetObj.investors;
		if (investors.includes("Fortcore Admin")) {
			return "Fortcore";
		} else {
			return investors.length > 1 ? "Investors" : `Investor-${investors[0]}`;
		}
	} else {
		return "N/A";
	}
};
